import { getBrandIdByName } from './brands';


const make = (config) => ({
  id: config.id,
  name: config.name,
  nameEn: config.name,
  nameAr: config.nameAr,
  brand: config.brand,
  brandAr: config.brandAr,
  brandId: getBrandIdByName(config.brand),
  category: config.category,
  categoryAr: config.categoryAr,
  size: config.size,
  price: config.price,
  image: config.image,
  imageHover: config.imageHover,
  detailImages: config.detailImages || [config.image, config.imageHover].filter(Boolean),
  description: config.description,
  descriptionAr: config.descriptionAr,
  ingredients: config.ingredients,
  ingredientsAr: config.ingredientsAr,
  benefits: config.benefits,
  benefitsAr: config.benefitsAr,
  section: 'new-luxury',
  hideSizes: true,
  sizes: [],
  inStock: true,
  rating: 4.8,
  reviews: 95 + ((config.id.length * 7) % 60),
});

export const NEW_LUXURY_PRODUCTS = [
  make({
    id: 'nl-pink-diamond-sakura',
    name: 'Pink Diamond Sakura',
    nameAr: 'بينك دايموند ساكورا',
    brand: 'Ibraheem Al Qurashi',
    brandAr: 'إبراهيم القرشي',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    size: '150ml',
    price: 2300,
    image: `/image/Perfume brands/Ibraq/pink-diamond-sakura-1.webp`,
    imageHover: `/image/Perfume brands/Ibraq/pink-diamond-sakura-2.webp`,
    description:
      'A captivating floral fragrance inspired by Japanese cherry blossoms. Soft, romantic and elegant with a refined powdery finish that lingers all day.',
    descriptionAr:
      'عطر زهري آسر مستوحى من زهور الكرز اليابانية. ناعم ورومانسي وأنيق بلمسة بودرية راقية تدوم طوال اليوم.',
    ingredients: ['Cherry Blossom', 'Rose', 'Vanilla', 'White Musk'],
    ingredientsAr: ['زهر الكرز', 'الورد', 'الفانيليا', 'المسك الأبيض'],
    benefits: [
      'Long-lasting feminine sillage',
      'Perfect for romantic evenings and daily wear',
      'Elegant powdery dry-down on skin',
    ],
    benefitsAr: [
      'سيليج نسائي يدوم طويلاً',
      'مثالي للأمسيات الرومانسية والاستخدام اليومي',
      'تجفيف بودري أنيق على البشرة',
    ],
  }),
  make({
    id: 'nl-grey-pearl-diamond',
    name: 'Grey Pearl Diamond',
    nameAr: 'جراي بيرل دايموند',
    brand: 'Ibraheem Al Qurashi',
    brandAr: 'إبراهيم القرشي',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    size: '150ml',
    price: 2300,
    image: `/image/Perfume brands/Ibraq/grey-pearl-1.jpg`,
    imageHover: `/image/Perfume brands/Ibraq/grey-pearl-2.webp`,
    description:
      'A sophisticated unisex composition with smoky elegance and modern warmth. A signature scent crafted for true connoisseurs of luxury.',
    descriptionAr:
      'تركيبة راقية للجنسين بأناقة دخانية ودفء عصري. عطر مميز يخاطب ذواقة الفخامة.',
    ingredients: ['Bergamot', 'Smoke', 'Oud', 'Amber', 'Musk'],
    ingredientsAr: ['البرغموت', 'الدخان', 'العود', 'العنبر', 'المسك'],
    benefits: [
      'Bold, mysterious presence',
      'Excellent projection and longevity',
      'Premium oils for a luxurious dry-down',
    ],
    benefitsAr: [
      'حضور جريء وغامض',
      'انتشار وثبات ممتاز',
      'زيوت فاخرة لتجفيف راقٍ',
    ],
  }),
  make({
    id: 'nl-balas-rose',
    name: 'Balas Rose',
    nameAr: 'بالاس روز',
    brand: 'Ibrahim Al Qurashi',
    brandAr: 'إبراهيم القرشي',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    size: '150ml',
    price: 2300,
    image: `/image/Perfume brands/Ibraq/balas-rose-1.jpeg`,
    imageHover: `/image/Perfume brands/Ibraq/balas-rose-2.jpeg`,
    description:
      'An opulent rose perfume crafted from the finest Damascene petals, paired with rich oriental accords for a timeless and luxurious signature.',
    descriptionAr:
      'عطر ورد فاخر مستخلص من أنقى بتلات الورد الدمشقي، ممزوج بنفحات شرقية غنية ليمنحك توقيعاً فاخراً خالداً.',
    ingredients: ['Damascene Rose', 'Saffron', 'Oud', 'Amber'],
    ingredientsAr: ['الورد الدمشقي', 'الزعفران', 'العود', 'العنبر'],
    benefits: [
      'Rich, opulent floral character',
      'Perfect for special occasions',
      'Long-lasting oriental dry-down',
    ],
    benefitsAr: [
      'شخصية زهرية فخمة وغنية',
      'مثالي للمناسبات الخاصة',
      'تجفيف شرقي يدوم طويلاً',
    ],
  }),
  make({
    id: 'nl-sapphire-leather',
    name: 'Sapphire Leather',
    nameAr: 'سافاير ليذر',
    brand: 'Ibrahim Al Qurashi',
    brandAr: 'إبراهيم القرشي',
    category: "Men's Fragrance",
    categoryAr: 'عطر رجالي',
    size: '150ml',
    price: 2300,
    image: `/image/Perfume brands/Ibraq/sapphire-leather-1.jpeg`,
    imageHover: `/image/Perfume brands/Ibraq/sapphire-leather-2.jpg`,
    description:
      'A bold leather fragrance with smooth modern facets. Confident, refined and unmistakably luxurious — a true statement scent.',
    descriptionAr:
      'عطر جلدي جريء بلمسات عصرية ناعمة. واثق وأنيق وفخم بلا منازع — عطر يصنع الحضور.',
    ingredients: ['Leather', 'Saffron', 'Birchwood', 'Patchouli'],
    ingredientsAr: ['الجلد', 'الزعفران', 'خشب البتولا', 'الباتشولي'],
    benefits: [
      'Strong masculine character',
      'Sophisticated leather signature',
      'Perfect for evenings and business',
    ],
    benefitsAr: [
      'شخصية رجالية قوية',
      'توقيع جلدي راقٍ',
      'مثالي للأمسيات والمواعيد المهنية',
    ],
  }),
  make({
    id: 'nl-black-diamond-incense',
    name: 'Black Diamond Incense',
    nameAr: 'بلاك دايموند بخور',
    brand: 'Ibraq',
    brandAr: 'إبراق',
    category: 'Oriental Niche',
    categoryAr: 'عطر شرقي راقٍ',
    price: 2300,
    image: `/image/Perfume brands/Ibraq/black-diamond-incense-1.webp`,
    imageHover: `/image/Perfume brands/Ibraq/black-diamond-incense-2.webp`,
    description:
      'A mysterious incense composition steeped in oriental tradition. Deep, smoky and ceremonial — a tribute to the heritage of Arabian perfumery.',
    descriptionAr:
      'تركيبة بخور غامضة عميقة الجذور في التراث الشرقي. عميقة ودخانية وطقوسية — تكريم لإرث العطور العربية.',
    ingredients: ['Incense', 'Oud', 'Frankincense', 'Resins'],
    ingredientsAr: ['البخور', 'العود', 'اللبان', 'الراتنجات الشرقية'],
    benefits: [
      'Deep, meditative aroma',
      'Heritage Arabian character',
      'Long-lasting ceremonial dry-down',
    ],
    benefitsAr: [
      'رائحة عميقة تأملية',
      'شخصية عربية تراثية',
      'تجفيف طقوسي يدوم طويلاً',
    ],
  }),
  make({
    id: 'nl-diamond-set',
    name: 'Diamond Collection Set',
    nameAr: 'مجموعة دايموند',
    brand: 'Ibraq',
    brandAr: 'إبراق',
    category: 'Gift Set',
    categoryAr: 'مجموعة هدايا',
    size: '3 Pcs',
    price: 3800,
    image: `/image/Perfume brands/Ibraq/diamond-set-1.jpg`,
    imageHover: `/image/Perfume brands/Ibraq/diamond-set-2.jpg`,
    description:
      'A curated trio of luxurious oriental fragrances. The perfect gift for the modern connoisseur who appreciates depth and craftsmanship.',
    descriptionAr:
      'ثلاثية مختارة من العطور الشرقية الفاخرة. الهدية المثالية للذواقة العصري الذي يقدر العمق والإتقان.',
    ingredients: ['Oud', 'Rose', 'Amber', 'Musk'],
    ingredientsAr: ['العود', 'الورد', 'العنبر', 'المسك'],
    benefits: [
      'Three premium scents in one set',
      'Ideal as a luxury gift',
      'Variety for every mood and occasion',
    ],
    benefitsAr: [
      'ثلاثة عطور فاخرة في مجموعة واحدة',
      'مثالية كهدية فاخرة',
      'تنوع لكل المزاج والمناسبات',
    ],
  }),
  make({
    id: 'nl-maroon-diamond',
    name: 'Maroon Diamond Set',
    nameAr: 'مجموعة مارون دايموند',
    brand: 'Ibraq',
    brandAr: 'إبراق',
    category: 'Gift Set',
    categoryAr: 'مجموعة هدايا',
    size: '3 × 75ml',
    price: 4200,
    image: `/image/Perfume brands/Ibraq/maroon-diamond-1.jpeg`,
    imageHover: `/image/Perfume brands/Ibraq/maroon-diamond-2.jpg`,
    description:
      'Three exquisite scents inspired by luxury and heritage. A complete olfactory journey delivered in one elegant set.',
    descriptionAr:
      'ثلاثة عطور رائعة مستوحاة من الفخامة والتراث. رحلة عطرية كاملة في مجموعة أنيقة واحدة.',
    ingredients: ['Saffron', 'Oud', 'Sandalwood', 'Vanilla'],
    ingredientsAr: ['الزعفران', 'العود', 'الصندل', 'الفانيليا'],
    benefits: [
      'Premium gift set presentation',
      'Three complementary luxury scents',
      'Excellent value for a complete collection',
    ],
    benefitsAr: [
      'تقديم فاخر للهدية',
      'ثلاثة عطور فاخرة متكاملة',
      'قيمة ممتازة لمجموعة كاملة',
    ],
  }),
  make({
    id: 'nl-mini-diamond-collection',
    name: 'Mini Diamond Collection',
    nameAr: 'مجموعة ميني دايموند',
    brand: 'Ibraq',
    brandAr: 'إبراق',
    category: 'Gift Set',
    categoryAr: 'مجموعة هدايا',
    size: '10 × 20ml',
    price: 5000,
    image: `/image/Perfume brands/Ibraq/mini-diamond-collection-1.jpeg`,
    imageHover: `/image/Perfume brands/Ibraq/mini-diamond-collection-2.jpeg`,
    detailImages: [
      `/image/Perfume brands/Ibraq/mini-diamond-collection-1.jpeg`,
      `/image/Perfume brands/Ibraq/mini-diamond-collection-2.jpeg`,
      `/image/Perfume brands/Ibraq/mini-diamond-collection-3.jpeg`,
      `/image/Perfume brands/Ibraq/mini-diamond-collection-4.jpeg`,
    ],
    description: 'A premium 10-piece mini diamond collection of unisex Eau de Parfum. Also available individually at 500 EGP per piece.',
    descriptionAr:
      'مجموعة ميني دايموند الفاخرة المكوّنة من 10 قطع من عطر أو دو بارفان للجنسين. متوفرة أيضاً بالقطعة بسعر 500 جنيه للقطعة.',
    ingredients: ['Musk', 'Rose', 'Amber', 'Oud'],
    ingredientsAr: ['المسك', 'الورد', 'العنبر', 'العود'],
    benefits: [
      'Luxury mini collection for gifting',
      'Ideal for trying multiple signature scents',
      'Available as a full set or single pieces',
    ],
    benefitsAr: [
      'مجموعة ميني فاخرة مثالية للإهداء',
      'مثالية لتجربة عدة عطور مميزة',
      'متوفرة كمجموعة كاملة أو قطع منفردة',
    ],
  }),
  make({
    id: 'nl-moon-collection',
    name: 'Moon Collection',
    nameAr: 'مون كوليكشن',
    brand: 'Ibraq',
    brandAr: 'إبراق',
    category: 'Gift Set',
    categoryAr: 'مجموعة هدايا',
    size: '75ml / 100ml / 150ml',
    price: 3500,
    image: `/image/Perfume brands/Ibraq/moon-collection-1.webp`,
    imageHover: `/image/Perfume brands/Ibraq/moon-collection-2.webp`,
    detailImages: [
      `/image/Perfume brands/Ibraq/moon-collection-1.webp`,
      `/image/Perfume brands/Ibraq/moon-collection-2.webp`,
      `/image/Perfume brands/Ibraq/moon-collection-3.webp`,
      `/image/Perfume brands/Ibraq/moon-collection-4.webp`,
    ],
    description: 'A luxurious moon-inspired collection crafted in three bottle sizes for a rich, long-lasting fragrance journey.',
    descriptionAr:
      'مجموعة فاخرة مستوحاة من القمر بثلاثة أحجام مختلفة لرحلة عطرية غنية تدوم طويلاً.',
    ingredients: ['Citrus', 'Amber', 'Musk', 'Oud'],
    ingredientsAr: ['الحمضيات', 'العنبر', 'المسك', 'العود'],
    benefits: [
      'Elegant trio with a premium presentation',
      'Rich, long-lasting scent profile',
      'Great for gifting and collection lovers',
    ],
    benefitsAr: [
      'ثلاثية أنيقة بتقديم فاخر',
      'تركيبة غنية تدوم طويلاً',
      'مثالية للإهداء ولعشاق المجموعات',
    ],
  }),
  make({
    id: 'nl-grey-diamond-collection',
    name: 'Grey Diamond Collection',
    nameAr: 'جراي دايموند كوليكشن',
    brand: 'Ibraq',
    brandAr: 'إبراق',
    category: 'Gift Set',
    categoryAr: 'مجموعة هدايا',
    size: '225ml',
    price: 4000,
    image: `/image/Perfume brands/Ibraq/grey-diamond-collection-1.jpg`,
    imageHover: `/image/Perfume brands/Ibraq/grey-diamond-collection-2.jpg`,
    detailImages: [
      `/image/Perfume brands/Ibraq/grey-diamond-collection-1.jpg`,
      `/image/Perfume brands/Ibraq/grey-diamond-collection-2.jpg`,
      `/image/Perfume brands/Ibraq/grey-diamond-collection-3.jpg`,
      `/image/Perfume brands/Ibraq/grey-diamond-collection-4.jpg`,
    ],
    description: 'A striking grey diamond collection presented as a luxurious 225 ml gift set with premium unisex character.',
    descriptionAr:
      'مجموعة جراي دايموند المميزة مقدّمة كطقم هدايا فاخر بسعة 225 مل بطابع راقٍ للجنسين.',
    ingredients: ['Oud', 'Musk', 'Amber', 'Saffron'],
    ingredientsAr: ['العود', 'المسك', 'العنبر', 'الزعفران'],
    benefits: [
      'Luxury presentation box',
      'Premium unisex scent profile',
      'Ideal for gifting and display',
    ],
    benefitsAr: [
      'علبة تقديم فاخرة',
      'تركيبة راقية للجنسين',
      'مثالية للإهداء والعرض',
    ],
  }),
  make({
    id: 'nl-maroon-diamond-box',
    name: 'Maroon Diamond Box',
    nameAr: 'مارون دايموند بوكس',
    brand: 'Ibraq',
    brandAr: 'إبراق',
    category: 'Gift Set',
    categoryAr: 'مجموعة هدايا',
    size: '225ml',
    price: 400,
    image: `/image/Perfume brands/Ibraq/maroon-diamond-box-1.jpg`,
    imageHover: `/image/Perfume brands/Ibraq/maroon-diamond-box-2.jpg`,
    detailImages: [
      `/image/Perfume brands/Ibraq/maroon-diamond-box-1.jpg`,
      `/image/Perfume brands/Ibraq/maroon-diamond-box-2.jpg`,
      `/image/Perfume brands/Ibraq/maroon-diamond-box-3.jpg`,
      `/image/Perfume brands/Ibraq/maroon-diamond-box-4.jpg`,
    ],
    description: 'A maroon diamond box featuring a refined trio-style presentation and a compact 225 ml luxury gift profile.',
    descriptionAr:
      'علبة مارون دايموند بتقديم ثلاثي أنيق وحجم فاخر مدمج بسعة 225 مل.',
    ingredients: ['Rose', 'Amber', 'Musk', 'Oud'],
    ingredientsAr: ['الورد', 'العنبر', 'المسك', 'العود'],
    benefits: [
      'Affordable luxury gift box',
      'Elegant compact presentation',
      'Great for gifting and sampling',
    ],
    benefitsAr: [
      'علبة هدايا فاخرة بسعر مناسب',
      'تقديم أنيق ومدمج',
      'مثالية للإهداء والتجربة',
    ],
  }),
  make({
    id: 'nl-musk-abazh',
    name: 'Musk Abazh Pomegranate',
    nameAr: 'مسك أبظ الرمان',
    brand: 'Ibraheem Al Qurashi',
    brandAr: 'إبراهيم القرشي',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    price: 500,
    image: `/image/Perfume brands/Ibraq/musk-abazh-1.jpg`,
    imageHover: `/image/Perfume brands/Ibraq/musk-abazh-2.jpg`,
    description:
      'A fresh musky composition with juicy pomegranate top notes. Light, modern and irresistibly clean — perfect for everyday luxury.',
    descriptionAr:
      'تركيبة مسكية منعشة بنفحات الرمان العصيرية. خفيف وعصري ونظيف بشكل لا يقاوم — مثالي للرفاهية اليومية.',
    ingredients: ['Pomegranate', 'White Musk', 'Rose', 'Sandalwood'],
    ingredientsAr: ['الرمان', 'المسك الأبيض', 'الورد', 'الصندل'],
    benefits: [
      'Fresh fruity opening',
      'Clean, modern dry-down',
      'Suitable for any time of day',
    ],
    benefitsAr: [
      'افتتاحية فاكهية منعشة',
      'تجفيف نظيف وعصري',
      'مناسب لأي وقت في اليوم',
    ],
  }),
  make({
    id: 'nl-musk-al-fajr',
    name: 'Musk Al Fajr',
    nameAr: 'مسك الفجر',
    brand: 'Ibraheem Al Qurashi',
    brandAr: 'إبراهيم القرشي',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    size: '75ml',
    price: 500,
    image: `/image/Perfume brands/Ibraq/musk-al-fajr-1.webp`,
    imageHover: `/image/Perfume brands/Ibraq/musk-al-fajr-2.webp`,
    description:
      'The serenity of dawn captured in a bottle. A pristine white musk with floral whispers and a soft, soothing aura.',
    descriptionAr:
      'سكون الفجر محفوظ في زجاجة. مسك أبيض نقي بهمسات زهرية وهالة هادئة ولطيفة.',
    ingredients: ['White Musk', 'Jasmine', 'Lily', 'Amber'],
    ingredientsAr: ['المسك الأبيض', 'الياسمين', 'زنبق الوادي', 'العنبر'],
    benefits: [
      'Soft, soothing musky aura',
      'Ideal for layering with other scents',
      'Versatile day-to-night profile',
    ],
    benefitsAr: [
      'هالة مسكية لطيفة وهادئة',
      'مثالي للتلبيس مع عطور أخرى',
      'يناسب النهار والليل',
    ],
  }),
  make({
    id: 'nl-powder-musk',
    name: 'Powder Musk',
    nameAr: 'باودر مسك',
    brand: 'Ibraheem Al Qurashi',
    brandAr: 'إبراهيم القرشي',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    size: '75ml',
    price: 500,
    image: `/image/Perfume brands/Ibraq/powder-musk-1.webp`,
    imageHover: `/image/Perfume brands/Ibraq/powder-musk-2.webp`,
    description:
      'A soft powdery musk that wraps the skin in elegant comfort. Subtle, sophisticated and timeless.',
    descriptionAr:
      'مسك بودري ناعم يحيط البشرة بأناقة دافئة. هادئ، راقٍ، خالد.',
    ingredients: ['White Musk', 'Powder', 'Vanilla', 'Iris'],
    ingredientsAr: ['المسك الأبيض', 'البودرة', 'الفانيليا', 'السوسن'],
    benefits: [
      'Comforting powdery accord',
      'Elegant skin-scent finish',
      'Suitable for all-day wear',
    ],
    benefitsAr: [
      'تركيبة بودرية مريحة',
      'لمسة أنيقة قريبة من البشرة',
      'مناسب طوال اليوم',
    ],
  }),
  make({
    id: 'nl-splandid',
    name: 'Splandid Pour Homme',
    nameAr: 'سبلانديد بور هوم',
    brand: 'Laura Mars',
    brandAr: 'لورا مارس',
    category: "Men's Fragrance",
    categoryAr: 'عطر رجالي',
    price: 1500,
    image: `/image/Perfume brands/Laura Mars/splandid-1.webp`,
    imageHover: `/image/Perfume brands/Laura Mars/splandid-2.webp`,
    detailImages: [
      `/image/Perfume brands/Laura Mars/splandid-1.webp`,
      `/image/Perfume brands/Laura Mars/splandid-2.webp`,
      `/image/Perfume brands/Laura Mars/splandid-3.webp`,
      `/image/Perfume brands/Laura Mars/splandid-4.webp`,
    ],
    description:
      'A masculine fragrance built for the modern gentleman. Fresh, magnetic and confidently refined.',
    descriptionAr:
      'عطر رجالي مصمم للرجل العصري. منعش وجذاب وواثق وأنيق.',
    ingredients: ['Bergamot', 'Lavender', 'Cedarwood', 'Vetiver'],
    ingredientsAr: ['البرغموت', 'اللافندر', 'خشب الأرز', 'الفتيفر'],
    benefits: [
      'Magnetic masculine aura',
      'Modern fresh-woody character',
      'Versatile for work and weekends',
    ],
    benefitsAr: [
      'هالة رجالية جذابة',
      'شخصية خشبية منعشة وعصرية',
      'يناسب العمل وعطلات نهاية الأسبوع',
    ],
  }),
  make({
    id: 'nl-lady-reef',
    name: 'Lady Reef',
    nameAr: 'ليدي ريف',
    brand: 'Reef',
    brandAr: 'ريف',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    price: 900,
    image: `/image/Perfume brands/Reef/lady-reef-1.jpg`,
    imageHover: `/image/Perfume brands/Reef/lady-reef-2.jpg`,
    description:
      'A graceful feminine scent inspired by ocean breezes and tropical blooms. Light, airy and delightful.',
    descriptionAr:
      'عطر نسائي رشيق مستوحى من نسائم البحر والأزهار الاستوائية. خفيف ولطيف ومرح.',
    ingredients: ['Tiare Flower', 'Sea Breeze', 'Vanilla', 'Coconut'],
    ingredientsAr: ['زهرة التياري', 'نسيم البحر', 'الفانيليا', 'جوز الهند'],
    benefits: [
      'Light, breezy feminine character',
      'Perfect for summer days',
      'Easy to wear and compliment-worthy',
    ],
    benefitsAr: [
      'شخصية نسائية خفيفة ومنعشة',
      'مثالي لأيام الصيف',
      'سهل الارتداء ويستحق الإطراء',
    ],
  }),
  make({
    id: 'nl-reef-bluest',
    name: 'Reef Bluest',
    nameAr: 'ريف بلوست',
    brand: 'Reef',
    brandAr: 'ريف',
    category: 'Aquatic Fragrance',
    categoryAr: 'عطر مائي',
    price: 900,
    image: `/image/Perfume brands/Reef/reef-bluest-1.jpg`,
    imageHover: `/image/Perfume brands/Reef/reef-bluest-2.jpg`,
    detailImages: [
      `/image/Perfume brands/Reef/reef-bluest-1.jpg`,
      `/image/Perfume brands/Reef/reef-bluest-2.jpg`,
      `/image/Perfume brands/Reef/reef-bluest-3.jpg`,
    ],
    description:
      'An aquatic adventure in a bottle — fresh, cool and revitalizing. Like a deep breath of sea air.',
    descriptionAr:
      'مغامرة مائية في زجاجة — منعش، بارد، ومنشّط. مثل نفس عميق من هواء البحر.',
    ingredients: ['Marine Accord', 'Citrus', 'Mint', 'Cedar'],
    ingredientsAr: ['نفحات بحرية', 'الحمضيات', 'النعناع', 'الأرز'],
    benefits: [
      'Refreshing aquatic opening',
      'Cool, energetic vibe',
      'Perfect for hot summer days',
    ],
    benefitsAr: [
      'افتتاحية مائية منعشة',
      'إحساس بارد ونشط',
      'مثالي لأيام الصيف الحارة',
    ],
  }),
  make({
    id: 'nl-reef-33',
    name: 'Reef 33 White',
    nameAr: 'ريف 33 الأبيض',
    brand: 'Reef',
    brandAr: 'ريف',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    price: 950,
    image: `/image/Perfume brands/Reef/reef-33-1.webp`,
    imageHover: `/image/Perfume brands/Reef/reef-33-2.webp`,
    detailImages: [
      `/image/Perfume brands/Reef/reef-33-1.webp`,
      `/image/Perfume brands/Reef/reef-33-2.webp`,
      `/image/Perfume brands/Reef/reef-33-3.webp`,
    ],
    description:
      'A clean modern white perfume. Effortless elegance for every occasion.',
    descriptionAr:
      'عطر أبيض نقي وعصري. أناقة سلسة لكل المناسبات.',
    ingredients: ['White Flowers', 'Aldehydes', 'Musk', 'Cotton'],
    ingredientsAr: ['الزهور البيضاء', 'الألدهيدات', 'المسك', 'القطن'],
    benefits: [
      'Crisp, clean signature',
      'Modern minimalist character',
      'Versatile for any setting',
    ],
    benefitsAr: [
      'توقيع نقي وعصري',
      'شخصية حديثة بسيطة',
      'يناسب أي مكان',
    ],
  }),
  make({
    id: 'nl-reef-summer-pink',
    name: 'Reef Summer Pink',
    nameAr: 'ريف سمر بينك',
    brand: 'Reef',
    brandAr: 'ريف',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    price: 900,
    image: `/image/Perfume brands/Reef/reef-summer-pink-1.jpg`,
    imageHover: `/image/Perfume brands/Reef/reef-summer-pink-2.jpg`,
    detailImages: [
      `/image/Perfume brands/Reef/reef-summer-pink-1.jpg`,
      `/image/Perfume brands/Reef/reef-summer-pink-2.jpg`,
      `/image/Perfume brands/Reef/reef-summer-pink-3.jpg`,
    ],
    description:
      'A cheerful summer scent blooming with playful pink petals. Sweet, fresh and irresistibly fun.',
    descriptionAr:
      'عطر صيفي مرح يزدهر ببتلات وردية ساحرة. حلو ومنعش وممتع لا يقاوم.',
    ingredients: ['Pink Pepper', 'Peony', 'Strawberry', 'White Musk'],
    ingredientsAr: ['الفلفل الوردي', 'الفاوانيا', 'الفراولة', 'المسك الأبيض'],
    benefits: [
      'Playful sweet character',
      'Perfect for warm sunny days',
      'Lifts your mood with every spray',
    ],
    benefitsAr: [
      'شخصية حلوة ومرحة',
      'مثالي للأيام المشمسة',
      'يرفع مزاجك مع كل رشة',
    ],
  }),
  make({
    id: 'nl-reef-29',
    name: 'Reef 29',
    nameAr: 'ريف 29',
    brand: 'Reef',
    brandAr: 'ريف',
    category: 'Travel Size',
    categoryAr: 'حجم سفر',
    size: '15ml',
    price: 450,
    image: `/image/Perfume brands/Reef/reef-29-1.jpg`,
    imageHover: `/image/Perfume brands/Reef/reef-29-2.jpg`,
    detailImages: [
      `/image/Perfume brands/Reef/reef-29-1.jpg`,
      `/image/Perfume brands/Reef/reef-29-2.jpg`,
      `/image/Perfume brands/Reef/reef-29-3.jpg`,
    ],
    description:
      'A compact perfume with a powerful signature. Travel-ready and ever ready to impress.',
    descriptionAr:
      'عطر بحجم صغير وتوقيع قوي. مثالي للسفر وجاهز ليبهر دائماً.',
    ingredients: ['Bergamot', 'Rose', 'Amber', 'Musk'],
    ingredientsAr: ['البرغموت', 'الورد', 'العنبر', 'المسك'],
    benefits: [
      'Convenient travel size',
      'Strong projection in a small bottle',
      'Carry your signature anywhere',
    ],
    benefitsAr: [
      'حجم مناسب للسفر',
      'انتشار قوي في زجاجة صغيرة',
      'احمل توقيعك في أي مكان',
    ],
  }),
  make({
    id: 'nl-rif-arab',
    name: 'Rif Arab',
    nameAr: 'ريف العرب',
    brand: 'Reef',
    brandAr: 'ريف',
    category: 'Oriental Fragrance',
    categoryAr: 'عطر شرقي',
    size: '100ml',
    price: 1100,
    image: `/image/Perfume brands/Reef/rif-arab-1.png`,
    imageHover: `/image/Perfume brands/Reef/rif-arab-2.png`,
    description:
      'A warm Arabian-inspired oriental fragrance. Rich, traditional and deeply evocative of the heritage of Arabian perfumery.',
    descriptionAr:
      'عطر شرقي دافئ مستوحى من التراث العربي. غني وتقليدي وعميق يستحضر إرث العطور العربية.',
    ingredients: ['Saffron', 'Oud', 'Amber', 'Rose'],
    ingredientsAr: ['الزعفران', 'العود', 'العنبر', 'الورد'],
    benefits: [
      'Rich Arabian heritage feel',
      'Long-lasting oriental dry-down',
      'Ideal for evening gatherings',
    ],
    benefitsAr: [
      'إحساس عربي تراثي غني',
      'تجفيف شرقي يدوم طويلاً',
      'مثالي للسهرات والمناسبات',
    ],
  }),
  make({
    id: 'nl-arab-obaya',
    name: 'Arab Obaya Body Spray',
    nameAr: 'بخاخ العباية العربي',
    brand: 'Reef',
    brandAr: 'ريف',
    category: 'Body Spray',
    categoryAr: 'بخاخ جسم',
    price: 700,
    image: `/image/Perfume brands/Reef/arab-obaya-1.webp`,
    imageHover: `/image/Perfume brands/Reef/arab-obaya-2.webp`,
    description:
      'A clean modern body spray with an Arabian touch. Fresh, lasting and confidently you.',
    descriptionAr:
      'بخاخ جسم عصري ونظيف بلمسة عربية. منعش، يدوم طويلاً وأنيق.',
    ingredients: ['Aldehydes', 'White Musk', 'Jasmine', 'Sandalwood'],
    ingredientsAr: ['الألدهيدات', 'المسك الأبيض', 'الياسمين', 'الصندل'],
    benefits: [
      'Light, refreshing body fragrance',
      'Ideal for everyday freshness',
      'Affordable luxury feel',
    ],
    benefitsAr: [
      'عطر جسم خفيف ومنعش',
      'مثالي للانتعاش اليومي',
      'لمسة فاخرة بسعر مناسب',
    ],
  }),
];
